<template>
    <div class="inline">
        <my-button class="btn btn-line-primary rounded-full" @click="openModal">
            <span>Send Private Message</span>
        </my-button>
        <form v-if="form && showModal" class="p-4 flex space-x-5 bg-gray-100" @submit.prevent="sendMessage">
            <modal v-if="showModal" :modal-title="`Type anything you want to say to ${user.name}`" @close="showModal = false">
                <template v-slot:body>
                    <div class="relative flex-1">
                        <my-textarea
                            v-model="form.message"
                            :rows="5"
                            name="message"
                            :error="form.errors.get('message')"
                            label="Your Message"
                        />
                    </div>
                </template>
                <template v-slot:footer>
                    <my-button
                        :loading="sending"
                        class="btn btn-primary px-6 md:px-8 font-bold float-right"
                        type="submit"
                        progress-text="Sending"
                    >
                        Send
                    </my-button>
                </template>
            </modal>
        </form>
    </div>
</template>

<script>
import Form from '../forms/form';

export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: new Form({
                message: null
            }),
            sending: false,
            showModal: false
        };
    },

    methods: {
        openModal() {
            if (!this.authUser()) window.location.href = '/register?as=employer';
            this.showModal = true;
        },

        sendMessage() {
            if (this.sending || !this.form.message) {
                return;
            }

            this.sending = true;

            axios
                .post(`/api/users/${this.user.id}/private-chat`, {
                    body: this.form.message
                })
                .then(response => {
                    this.showModal = false;
                    window.location.href = '/my-conversations?active_conversation=' + response.data.conversation.id;
                })
                .catch(() => flash.error())
                .finally(() => {
                    this.sending = false;
                    this.form.message = null;
                });
        }
    }
};
</script>
